// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Speech__ListItemText {\n  max-width: 50%;\n}\n\n.Speech__VoiceMenuItemText {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  min-width: 100%;\n}\n\n.Speech__VoiceLabel:hover {\n  overflow: visible;\n  white-space: normal;\n  height: auto;\n}\n\n.Speech__VoiceLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 20px;\n  white-space: nowrap;\n  max-width: 80%;\n}\n\n.MuiChip-root {\n  margin-left: auto;\n}\n", ""]);
// Exports
module.exports = exports;
